<template>
  <div :class="classDiv">
    <img
      ref="imagen-jornada"
      src="@/assets/img/iconos/jornada-dia.svg"
      :style="styleImg"
      :class="classImg"
      v-if="jornada === 'DIURNO'"
    />
    <img
      ref="imagen-jornada"
      src="@/assets/img/iconos/jornada-noche.svg"
      :style="styleImg"
      :class="classImg"
      v-else-if="jornada === 'VESPERTINO'"
    />
    <img
      ref="imagen-jornada"
      src="@/assets/img/iconos/modo-a-distancia-2.svg"
      :style="styleImg"
      :class="classImg"
      v-else-if="jornada === 'A_DISTANCIA'"
    />
    <img
      ref="imagen-jornada"
      src="@/assets/img/iconos/modo-semi-presencial-2.svg"
      :style="styleImg"
      :class="classImg"
      v-else-if="jornada === 'SEMIPRESENCIAL'"
    />
    <img
      ref="imagen-jornada"
      src="@/assets/img/iconos/no-aplica.svg"
      :style="styleImg"
      :class="classImg"
      v-else
    />
    <b-tooltip
      :disabled.sync="tooltipDisabled"
      :target="() => $refs['imagen-jornada']"
      :title="textoTooltip"
    ></b-tooltip>
  </div>
</template>

<script>
export default {
  name: "Jornada",
  props: {
    jornada: { type: String },
    tooltipDisabled: { type: Boolean, default: false },
    styleImg: { type: String },
    classImg: { type: String },
    classDiv: { type: String }
  },
  computed: {
    textoTooltip() {
      switch (this.jornada) {
        case "DIURNO":
            return 'Presencial diurno'
          break;
        case "VESPERTINO":
            return 'Presencial vespertino'
          break;
        case "A_DISTANCIA":
            return 'A distancia'
          break;
        case "SEMIPRESENCIAL":
            return 'Semipresencial'
          break;
        default:
            return 'No especifica jornada'
          break;
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/iconos/Jornada.vue